<mbs-modal
  #modal
  [isCustomModal]="true"
  [limitedHeight]="true"
  [title]="'shared:administrators.presets.editPresetTitle' | i18next: { name: preset?.name }">
  <ng-container modal-body>
    <mbs-alert [type]="MbsPopupType.info">
      {{ 'shared:administrators.presets.editHint' | i18next }}
    </mbs-alert>

    <div class="mbs-form-group">
      <mbs-input
        [formControl]="nameControl"
        [label]="'shared:administrators.presets.presetName' | i18next"
        [labelClasses]="'fw-bold'"
        [placeholder]="'shared:administrators.presets.presetNamePlaceholder' | i18next"
        [showRequiredMark]="false"
        [validationWhitespace]="true"></mbs-input>
    </div>

    <mbs-permissions-tree
      [accountType]="accountType"
      [globalMcpLevel]="mcpSettings.globalLevel()"
      [idPrefix]="'preset-'"
      [permissions]="permissions"
      [showTiles]="false"
      (permissionsChange)="permissions = $event"></mbs-permissions-tree>
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [disabled]="nameControl.invalid"
      [loading]="loading"
      (click)="save()">
      {{ 'shared:buttons.save' | i18next }}
    </mbs-button>
    <mbs-button
      data-dismiss="modal"
      type="secondary"
      (click)="modal.close()">
      {{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
